import { MINIMUM_CASE_CBS } from '../../../../../constants/appConstants';

export const getCaseCuttedBuiltSurfaceMinimum = (): number => {
  return MINIMUM_CASE_CBS;
};
